import { atom } from "recoil";

const pictCommentAtom = atom({
  key: "pictCommentState",
  default: "",
});

export default pictCommentAtom;
